import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';
import { RechardUSDTInput } from 'src/models/recharge.model';

@Injectable()
export class RechargeService {
    constructor(
        private httpService: HttpService) { }

    //获取充值银行
    //TQQ 2017-05-03
    getBanks() {
        let url = AppConfig.GetProdUrl() + "/Index/Banks";
        return this.httpService.get(url);
    }

    //充值
    //TQQ 2017-05-09
    recharege(params) {
        let url = AppConfig.GetProdUrl() + "/Funds/Recharge";
        return this.httpService.get(url, params);
    }

    //支付宝人工充值
    //TQQ 2017-05-09
    rechardZfbrg(params) {
        let url = AppConfig.GetProdUrl() + "/Funds/RechardZfbrg";
        return this.httpService.get(url, params);
    }

    //汇鑫充值
    //TQQ 2017-05-09
    huixinRecharge(params) {
        let url = AppConfig.GetProdUrl() + "/Funds/RechargeHuixin";
        return this.httpService.get(url, params);
    }

    //支付宝自动
    //TQQ 2017-05-10
    rechardZfbzd(params) {
        let url = AppConfig.GetProdUrl() + "/Funds/RechardZfbzd";
        return this.httpService.get(url, params);
    }
    // 获取转账设置
    gettransferset() {
        let url = AppConfig.GetProdUrl() + "/Funds/GetTransferSetting";
        return this.httpService.get(url);
    }

    /**
     * 修改充值记录的备注
     * TQQ 2018-11-07
     */
    updateCommt(parms) {
        let url = AppConfig.GetProdUrl() + "/Funds/UpdateCommtReCharge";
        return this.httpService.get(url, parms);
    }

    /**
     * 获取第三方网银列表
     * TQQ 2018-12-27
     */
    getThirdWyList(bankCode) {
        let url = AppConfig.GetProdUrl() + "/Index/GetThirdWyList";
        return this.httpService.post(url, { bankCode: bankCode });
    }

    /**
     * 创建线下充值订单
     * @param {*} params
     * @returns
     * @memberof RechargeService
     */
    AddRechardNewCode(params) {
        let url = AppConfig.GetProdUrl() + "/Funds/AddOfflineRechard";
        return this.httpService.post(url, params);
    }

    /**
     * 线下订单提交审核
     * @param {*} params
     * @returns
     * @memberof RechargeService
     */
    sureOfflineRechard(params) {
        let url = AppConfig.GetProdUrl() + "/Funds/SureOfflineRechard";
        return this.httpService.post(url, params);
    }

    // 获取USDT
    getUSDTSetting() {
        let url = AppConfig.GetProdUrl() + "/Funds/GetUSDTSetting";
        return this.httpService.get(url);
    }
    // USDT开关
    addUSDTRechard(input: RechardUSDTInput) {
        let url = AppConfig.GetProdUrl() + "/Funds/AddRechardUSDT";
        return this.httpService.post(url, input);
    }
    /**
 * 口令红包
 */
    updateCommtReCharge(commit, surname, recordCode) {
        let url = AppConfig.GetProdUrl() + "/Funds/UpdateCommtReCharge?commit=" + commit + ',' + surname + "&recordCode=" + recordCode;
        return this.httpService.get(url);
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/recharge.service.ts